/* Input, textarea, and label primitives.
   Pure code-motion from src/App.jsx (Phase 2 group 3). */

import { brand } from './brand.js';

export const inputStyle = {
  width: "100%",
  padding: "9px 12px",
  fontSize: "13px",
  fontFamily: brand.font,
  border: `1px solid ${brand.borderLight}`,
  borderRadius: "6px",
  color: brand.textPrimary,
  backgroundColor: brand.white,
  boxSizing: "border-box",
};

export const textareaStyle = {
  ...inputStyle,
  minHeight: "120px",
  resize: "vertical",
  lineHeight: "1.5",
};

export const labelStyle = {
  display: "block",
  fontSize: "12px",
  fontWeight: "600",
  color: brand.textSecondary,
  marginBottom: "4px",
  fontFamily: brand.font,
  textTransform: "uppercase",
  letterSpacing: "0.03em",
};
